module.exports = "<div class=\"card\">\r\n    <iframe src=\"https://drive.google.com/file/d/1EH3dKjdpQWzbdodTm7j9UTmogU85aw4M/preview\"  style=\"height: calc(100vh - 70px);\" ></iframe>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/help/components/help-page/help-page.component.html
// module id = ./src/app/modules/help/components/help-page/help-page.component.html
// module chunks = main